<template>
  <!-- 
    Code By     : 陈伦刚
    CreateTime  : 2021-04-13 05:01:00
    Description : 年度获奖
  -->
  <div class="main">
    <div class="background">
      <div class="logo" :style="{ background: `url(${logo})` }"></div>
      <div class="title">所有作品受版权保护</div>
    </div>
    <div class="year-bar">
      <el-dropdown @command="yearBarClick" trigger="click">
        <span class="el-dropdown-link select">
          {{ year + "年度" }}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item
            v-for="(item, i) in yearsList"
            :key="i"
            :command="item.year"
          >
            {{ item.year }}年度
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div style="background: #fff; padding: 40px 0; min-width: 1300px">
      <div class="image"></div>
    </div>
    <div
      class="optimal"
      v-for="(item, i) in mostList"
      :key="i"
      v-if="awardsRecordList.length > 0 && item.id === optimalIndex"
    >
      <div class="gaia-48-bar" :style="{ background: `url(${gaia48bar})` }">
        <div style="width: 1300px; margin: 0 auto">
          <div>
            <img style="width: 280px; height: 130px" :src="item.logo" />
          </div>
          <div class="most-item">
            <div class="cover">
              <img :src="item.cover" />
            </div>
            <div class="info">
              <div class="title">{{ item.title }}</div>
              <div class="people">
                {{ item.people }}
              </div>
              <div class="introduction">
                <div v-html="item.introduction"></div>
              </div>
              <div
                class="play"
                @click="jumpTo(`/desktop/gaia-48/detail?id=${item.id}`)"
              >
                <img :src="playBtn" />
              </div>
            </div>
            <div class="fraction">
              <img style="width: 200px; height: 90px" :src="item.logo2" />
              <br />
              <ul>
                <li>最后得分：{{ item.artScore }} <span></span></li>
                <li>剧本：{{ item.avgScore }}<span></span></li>
                <li>叙事完整性：{{ item.clipScore }} <span></span></li>
                <li>拍摄成熟度：{{ item.directorscore }}<span></span></li>
                <li>剪辑流畅度：{{ item.photogrephyScore }} <span></span></li>
                <li>视觉优美性：{{ item.scriptScore }}<span></span></li>
                <li>技术先进性：{{ item.showScore }} <span></span></li>
                <li>整体艺术表现：{{ item.soundSore }}<span></span></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="optimal-radio">
      <div
        v-for="(item, i) in awardsRecordList"
        :key="item.id"
        class="item"
        :class="{ active: optimalIndex === item.hourWorks.id }"
        @click="optimalIndex = item.hourWorks.id"
      >
        {{ item.awards.name }}
      </div>
    </div>
    <div class="all-works">
      <div class="h1">全部作品</div>
      <div class="item" v-for="(item, i) in worksList" :key="item.id">
        <div
          class="cover"
          :style="{
            background: `url(${baseUrl + item.cover})`,
            backgroundSize: '100% 100%',
          }"
          @click="openDetail(item.id)"
        ></div>
        <good-one
          :theme="item.like ? 'filled' : 'outline'"
          size="40"
          fill="#be5af2"
          style="cursor: pointer"
          @click="worksAgree(item.id)"
        />
        <div class="votes">投票 ({{ item.likeCount }})</div>
        <div class="title">{{ item.title }}</div>
        <div class="number">No. {{ item.number }}</div>
      </div>
      <div style="text-align: center">
        <el-pagination
          background
          layout="prev, pager, next"
          :page-size="page.pageSize"
          :total="page.total"
          :current-page="page.pageIndex"
          @current-change="getShowWorksByYear"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  getYears,
  getShowWorksByYear,
  getAreaYearDetail,
  worksAgree,
} from "@/api/newgaia48";
import { GoodOne } from "@icon-park/vue";
export default {
  components: {
    GoodOne,
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_RESOURCES_URL,
      logo: require("../../assets/images/gaia48/年度展映.png"),
      checkbox: 0,
      gaia48bar: require("../../assets/images/gaia48/gaia48-bar.png"),
      year: "2018",
      playBtn: require("../../assets/images/gaia48/play-btn.png"),
      mostList: [
        {
          id: 3,
          logo:
            "https://pub-glb.cn-e1.acs-cdn.gaiamount.com/image/cover/u7714/20190531-144630.png",
          logo2:
            "https://pub-glb.cn-e1.acs-cdn.gaiamount.com/image/cover/u7714/20190531-144811.png",
          cover:
            "https://pub-glb.cn-e1.acs-cdn.gaiamount.com/smallFile/4/15159505581441aeb.jpg",
          title: "朵儿",
          people:
            "导演：夏梦怡 / 摄影：董潇涵 / 编剧：夏梦怡 / 副摄影：李涛 / 摄影助理：郭翔宇 / 灯光：焦保全 钱陈虎 / 录音：李森 高小雷 / 场记：刘爽 孟明璐 / 统筹：若虚 / 制片：何宇 / 化妆：公丽君 / 剧务：吴欣 杜宇非 周建 / 纪录片摄影：王茁旭 / 后期剪辑：夏梦怡 李涛 / 调色：冬菇童鞋 / 声音制作：韩志超",
          introduction:
            "朵儿妈为了孩子好，将自己的女儿朵儿送去学习提琴，在学习的过程中，老师对她做出一些奇怪的举动，并告诉朵儿，这是他们之间的小秘密。一个小小的木推子成为老师贿赂孩子的工具。当一天的学习结束了，妈妈接拿着木推子的朵儿回家，和她们擦肩而过的，是另一对拿着木推子的父女......",
        },
      ],
      optimalIndex: 0,
      yearsList: [],
      page: {
        pageIndex: 1,
        pageSize: 9,
        total: 0,
      },
      worksList: [],
      awardsRecordList: [], // 获奖列表
    };
  },
  created() {
    this.getYears();
  },
  methods: {
    getYears() {
      getYears().then((res) => {
        console.log(res);
        this.yearsList = res.years.filter((item) => {
          return !item.deleted;
        });
        this.year = this.yearsList[0].year;
        this.getShowWorksByYear();
      });
    },
    yearBarClick(i) {
      this.year = i;
      this.getShowWorksByYear();
    },
    getShowWorksByYear(num = 1) {
      this.page.pageIndex = num;
      const data = {
        keyword: "",
        oderType: "time",
        pageIndex: this.page.pageIndex,
        pageSize: this.page.pageSize,
        year: parseInt(this.year),
      };
      getShowWorksByYear(data).then((res) => {
        console.log(res);
        this.worksList = res.allHourWorksDtos;
        this.page = res.page;
        this.getAreaYearDetail();
        this.page = res.page;
      });
    },
    getAreaYearDetail() {
      getAreaYearDetail(this.year).then((res) => {
        console.log(res);
        this.awardsRecordList = res.awardsRecordList;
        this.optimalIndex = this.awardsRecordList[0].hourWorks.id;
        this.mostList = this.awardsRecordList.map((el) => {
          return {
            id: el.hourWorks.id,
            logo: this.baseUrl + el.awards.awardsCover,
            logo2: this.baseUrl + el.awards.medalCover,
            title: el.hourWorks.title,
            cover: this.baseUrl + el.hourWorks.cover,
            people: el.hourWorks.creators
              .map((el) => {
                return `${el.position}：${el.name}`;
              })
              .join(" / "),
            introduction: el.hourWorks.description,
            artScore: (el.artScore / 100).toFixed(2),
            avgScore: (el.avgScore / 100).toFixed(2),
            clipScore: (el.clipScore / 100).toFixed(2),
            directorscore: (el.directorscore / 100).toFixed(2),
            photogrephyScore: (el.photogrephyScore / 100).toFixed(2),
            scriptScore: (el.scriptScore / 100).toFixed(2),
            showScore: (el.showScore / 100).toFixed(2),
            soundSore: (el.soundSore / 100).toFixed(2),
          };
        });
      });
    },
    currentChange() {
      console.log("currentChange");
    },
    openDetail(id) {
      open(`/desktop/gaia-48/detail?id=${id}`);
    },
    jumpTo(url) {
      open(url);
    },
    worksAgree(id) {
      worksAgree(id).then((res) => {
        this.getShowWorksByYear(this.page.pageIndex);
        if (res.msg.includes("cancel")) {
          this.$message.success("取消点赞成功");
        } else {
          this.$message.success("点赞成功");
        }
      });
    },
  },
};
</script>
<style lang="less" >
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #ffa200;
}
</style>
<style lang="less" scoped>
.main {
  padding-top: 70px;
  // background: #888;
}
.logo {
  display: inline-block;
  width: 220px;
  height: 63px;
}
.title {
  font-size: 14px;
  color: #000;
  letter-spacing: 8px;
}
.background {
  width: 100%;
  min-width: 1300px;
  height: 300px;
  background: url(https://pub-glb.cn-e1.acs-cdn.gaiamount.com/image/cover/u6100/20181213-111153.jpeg)
    no-repeat;
  background-size: 100% 100%;
  text-align: center;
  padding-top: 120px;
  margin-top: 10px;
}
.year-bar {
  min-width: 1300px;
  width: 100%;
  height: 66px;
  line-height: 66px;
  background: #414141;
  text-align: center;
}
.select {
  font-size: 24px;
  color: #d6ba92;
  cursor: pointer;
}
.image {
  width: 225px;
  height: 121px;
  margin: 0 auto;
  background: url(https://48.gaiamount.com/static/img/year-logo.7fa4840.png);
  background-color: #ffffff;
}
.optimal {
  width: 100%;
  min-width: 1300px;
  height: 820px;
  background: #1a1a1a;
}
.gaia-48-bar {
  width: 100%;
  height: 130px;
}
.el-dropdown-menu__item {
  font-size: 24px;
}
.most-item {
  display: flex;
  padding: 100px 40px 140px;
  .cover {
    width: 294px;
    height: 410px;
    border: 4px solid #3f3f3f;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .info {
    width: 700px;
    padding: 0 5%;
    .title {
      overflow: hidden; //超出的文本隐藏
      text-overflow: ellipsis; //溢出用省略号显示
      white-space: nowrap; //溢出不换行
      font-size: 60px;
      color: #ffffff;
    }
    .people {
      min-height: 75px;
      max-height: 75px;
      font-size: 20px;
      margin-top: 30px;
      margin-bottom: 34px;
      line-height: 1.2;
      color: #fff;
      overflow: hidden;
    }
    .introduction {
      font-size: 16px;
      color: #b2b2b2;
      line-height: 1.5;
      margin-bottom: 88px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;
      overflow: hidden;
      max-height: 110px;
    }
    .play {
      display: block;
      width: 240px;
      height: 50px;
      line-height: 65px;
      background: #404040;
      text-align: center;
      cursor: pointer;
    }
  }
  .fraction {
    width: 240px;
    font-size: 14px;
    line-height: 30px;
    margin-bottom: 10px;
    color: gray;
  }
}
.optimal-radio {
  display: flex;
  margin: -60px auto 60px;
  width: 700px;
  justify-content: space-around;
  background: #1a1a1a;
  .item {
    width: auto;
    padding-bottom: 10px;
    font-size: 16px;
    margin: 0 10px 0;
    white-space: nowrap;
    color: #5f5f5f;
    text-align: center;
    cursor: pointer;
    transition: all 0.2s;
  }
  .item.active {
    border-bottom: solid 5px #a314ed;
    color: #a314ed;
    transition: all 0.2s;
  }
}
.all-works {
  width: 1300px;
  margin: 0 auto;
  padding: 100px 40px 140px;
  .h1 {
    width: 160px;
    font-size: 24px;
    margin: 0 0 40px;
    padding-bottom: 10px;
    font-weight: bold;
    color: #000000;
    border-bottom: solid 6px #a314ed;
  }
  .item {
    display: inline-block;
    width: 300px;
    height: 620px;
    margin-right: 160px;
    text-align: center;
    .cover {
      width: 100%;
      height: 420px;
      margin-bottom: 10px;
      border: 4px solid #3f3f3f;
      background: #000000;
      cursor: pointer;
    }
    .title {
      font-size: 28px;
      font-weight: 400;
      color: #000000;
    }
    .votes {
      font-size: 14px;
      color: gray;
    }
    .number {
      font-size: 20px;
      color: #000;
    }
  }
  .item:nth-child(3n + 1) {
    margin-right: 0;
  }
}
</style>